import React from 'react'
import { BsBoxes } from "react-icons/bs";
import { FaBookBookmark } from "react-icons/fa6";
import { GiToolbox } from "react-icons/gi";
import { GrDocumentNotes } from "react-icons/gr";
import home_icon from '../Image/home_icon.svg'
import home_icon2 from '../Image/home_icon2.jpg'
import home_icon3 from '../Image/home_icon3.jpg'
import home_icon4 from '../Image/home_icon4.jpg'

function Mobile_About_card() {
  return (
    <div>
    <div className='mobile_about_card mt-2'>
        <div id="carouselExampleFade" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-inner shadow-lg  mobile_about_card">
            <div class="carousel-item active">
            <div className='container shadow about_card  text-center'>
                <div className='py-2'>
                    <img className='home_icon' src={home_icon}></img>
                </div>
                    <span className='fs-5 fw-bold why_choose_text'>Continuous Innovation</span>
                    <p className='pt-3 px-2 mobile_why_choose_text_p'> We remain at the forefront of educational innovation, constantly evolving our services to offer the latest in E-learning technology and methodologies, ensuring a cutting-edge learning experience.</p>
                </div>
            </div>
            <div class="carousel-item">
            <div className=''>
            <div className='container shadow about_card  text-center'>
                <div className='py-2'>
                    <img className='home_icon2' src={home_icon2}></img>
                </div>
                <span className='fs-5 fw-bold why_choose_text'>Tailored Curriculum</span>
                <p className='pt-3 px-2 mobile_why_choose_text_p'>We curate specialized learning paths, tailored to meet diverse educational needs, ensuring a comprehensive and enriching experience for all learners.</p>
            </div>
            </div>
            </div>
            <div class="carousel-item">
            <div className='container shadow about_card  text-center'>
                <div className='py-2 mt-2'>
                    <img className='home_icon3' src={home_icon3}></img>
                </div>
                <span className='fs-5 fw-bold why_choose_text'>Interactive Learning Tools</span>
                <p className='pt-3 px-2 mobile_why_choose_text_p'>Our platform incorporates state-of-the-art interactive tools, fostering engaging and immersive learning experiences that captivate and inspire.</p>
            </div>
            </div>
            <div class="carousel-item ">
            <div className='container shadow about_card  text-center'>
                <div className='py-2'>
                    <img className='home_icon4' src={home_icon4}></img>
                </div>
                <span className='fs-5 fw-bold why_choose_text'>Expert Guidance</span>
                <p className='pt-3 px-2 mobile_why_choose_text_p'>Learners benefit from expert guidance and support, ensuring they navigate through courses with clarity and confidence, backed by our experienced educators.</p>
            </div>
            </div>
        </div>
        <button class="carousel-control-prev slider_button" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
            <span class="carousel-control-prev-icon " Testmonnial_slider_iconen="true"></span>
            <span class="visually-hidden">Previous</span>
        </button>
        <button class="carousel-control-next slider_button" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
            <span class="carousel-control-next-icon " aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
        </button> 
        </div>
    </div>       
    </div>
  )
}

export default Mobile_About_card
